import { useEffect } from "react";

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

  .policy-page { font-family: 'DM Sans', sans-serif; background: #f8f6f0; min-height: 100vh; color: #1a1a2e; }

  .policy-hero {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
    padding: 80px 40px 60px;
    position: relative;
    overflow: hidden;
  }
  .policy-hero::before {
    content: ''; position: absolute; top: -50%; right: -10%;
    width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(229,160,13,0.15) 0%, transparent 70%);
    border-radius: 50%;
  }
  .policy-hero::after {
    content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 4px;
    background: linear-gradient(90deg, #e5a00d, #f0c040, #e5a00d);
  }
  .brand-badge {
    display: inline-flex; align-items: center; gap: 10px;
    background: rgba(229,160,13,0.15); border: 1px solid rgba(229,160,13,0.3);
    padding: 8px 20px; border-radius: 50px; margin-bottom: 24px;
  }
  .brand-dot { width:8px; height:8px; background:#e5a00d; border-radius:50%; animation: pulse 2s infinite; }
  @keyframes pulse { 0%,100%{opacity:1;transform:scale(1)} 50%{opacity:0.5;transform:scale(0.8)} }
  .brand-name { color:#e5a00d; font-size:13px; font-weight:600; letter-spacing:2px; text-transform:uppercase; }
  .policy-title { font-family:'Playfair Display',serif; font-size:clamp(36px,5vw,56px); font-weight:800; color:#fff; margin:0 0 16px; line-height:1.1; }
  .policy-subtitle { color:rgba(255,255,255,0.6); font-size:15px; font-weight:300; max-width:500px; }
  .policy-meta { display:flex; gap:16px; margin-top:32px; flex-wrap:wrap; }
  .meta-chip { background:rgba(255,255,255,0.08); border:1px solid rgba(255,255,255,0.12); padding:6px 16px; border-radius:6px; color:rgba(255,255,255,0.7); font-size:12px; font-weight:500; }

  .policy-body { max-width:860px; margin:0 auto; padding:60px 40px; }

  .toc-card { background:#fff; border:1px solid #e8e4da; border-radius:16px; padding:32px; margin-bottom:48px; box-shadow:0 2px 20px rgba(0,0,0,0.04); }
  .toc-title { font-family:'Playfair Display',serif; font-size:18px; font-weight:700; margin:0 0 20px; color:#1a1a2e; }
  .toc-list { list-style:none; padding:0; margin:0; display:grid; grid-template-columns:1fr 1fr; gap:8px; }
  .toc-item a { color:#0f3460; text-decoration:none; font-size:14px; font-weight:500; display:flex; align-items:center; gap:8px; padding:6px 0; transition:color 0.2s; }
  .toc-item a:hover { color:#e5a00d; }
  .toc-num { width:22px; height:22px; background:#f0ece4; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:11px; font-weight:600; color:#0f3460; flex-shrink:0; }

  .policy-section { margin-bottom:48px; }
  .section-header { display:flex; align-items:center; gap:16px; margin-bottom:20px; }
  .section-number { width:44px; height:44px; background:linear-gradient(135deg,#1a1a2e,#0f3460); color:#e5a00d; font-family:'Playfair Display',serif; font-size:16px; font-weight:700; border-radius:12px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .section-title { font-family:'Playfair Display',serif; font-size:22px; font-weight:700; color:#1a1a2e; margin:0; }
  .section-content { background:#fff; border:1px solid #e8e4da; border-radius:12px; padding:28px 32px; line-height:1.8; font-size:15px; color:#3a3a50; box-shadow:0 1px 8px rgba(0,0,0,0.03); }
  .section-content p { margin:0 0 16px; } .section-content p:last-child { margin:0; }

  .highlight-box { background:linear-gradient(135deg,#fffbf0,#fff8e6); border-left:4px solid #e5a00d; border-radius:0 8px 8px 0; padding:16px 20px; margin:16px 0; font-size:14px; }

  .data-list { list-style:none; padding:0; margin:12px 0; }
  .data-list li { display:flex; align-items:flex-start; gap:10px; padding:8px 0; border-bottom:1px solid #f0ece4; font-size:14px; }
  .data-list li:last-child { border-bottom:none; }
  .data-list li::before { content:'✦'; color:#e5a00d; font-size:10px; margin-top:4px; flex-shrink:0; }

  .contact-card { background:linear-gradient(135deg,#1a1a2e,#0f3460); border-radius:16px; padding:36px; text-align:center; margin-top:48px; color:white; }
  .contact-card h3 { font-family:'Playfair Display',serif; font-size:24px; margin:0 0 12px; color:#e5a00d; }
  .contact-card p { color:rgba(255,255,255,0.7); margin:0 0 24px; font-size:14px; }
  .contact-links { display:flex; justify-content:center; gap:16px; flex-wrap:wrap; }
  .contact-link { background:rgba(229,160,13,0.15); border:1px solid rgba(229,160,13,0.4); color:#e5a00d; padding:10px 24px; border-radius:8px; text-decoration:none; font-size:14px; font-weight:500; transition:all 0.2s; }
  .contact-link:hover { background:#e5a00d; color:#1a1a2e; }

  @media(max-width:600px) {
    .policy-hero{padding:60px 20px 40px} .policy-body{padding:40px 20px}
    .toc-list{grid-template-columns:1fr} .section-content{padding:20px}
  }
`;

const sections = [
  {
    num: "01", id: "info-collect", title: "Information We Collect",
    content: (<>
      <p>When you use the ITI Expert Guruji platform, we collect the following information:</p>
      <ul className="data-list">
        <li>Full name, email address, and phone number (during registration)</li>
        <li>School / college name and class or grade</li>
        <li>Payment information (stored in encrypted form)</li>
        <li>Study progress, quiz scores, and exam results</li>
        <li>Device information and IP address</li>
        <li>Website usage logs and cookies</li>
      </ul>
      <div className="highlight-box"><strong>Important:</strong> We handle information of minor students with extra care. Parental consent is required for students under 13 years of age.</div>
    </>),
  },
  {
    num: "02", id: "info-use", title: "How We Use Your Information",
    content: (<>
      <p>The collected information is used for the following purposes:</p>
      <ul className="data-list">
        <li>Creating your account and providing login access</li>
        <li>Delivering course content and educational materials</li>
        <li>Processing payments and sending receipts or invoices</li>
        <li>Analyzing study progress and providing personalized recommendations</li>
        <li>Technical support and customer service</li>
        <li>Notifications about new courses and offers (opt-out available)</li>
      </ul>
    </>),
  },
  {
    num: "03", id: "info-share", title: "Information Sharing Policy",
    content: (<>
      <p>ITI Expert Guruji does <strong>not sell</strong> your personal information to third parties. Information is shared only in the following situations:</p>
      <ul className="data-list">
        <li>Payment gateway (Razorpay / PayU) – for payment processing only</li>
        <li>School / college administration – for student progress reports</li>
        <li>Government authorities as required by applicable law</li>
        <li>Cloud service providers for platform security and operations</li>
      </ul>
      <div className="highlight-box">All third-party providers comply with Indian IT laws and GDPR regulations.</div>
    </>),
  },
  {
    num: "04", id: "data-security", title: "Data Security",
    content: (<>
      <p>We take the following measures to keep your information secure:</p>
      <ul className="data-list">
        <li>SSL/TLS encryption – all data transfers are fully encrypted</li>
        <li>Passwords – secured using bcrypt hashing technology</li>
        <li>Payment data – stored on PCI-DSS compliant servers</li>
        <li>Regular security audits and vulnerability assessments</li>
        <li>Two-factor authentication (2FA) option available for all users</li>
      </ul>
    </>),
  },
  {
    num: "05", id: "cookies", title: "Cookies Policy",
    content: (<>
      <p>ITI Expert Guruji uses cookies and similar technologies:</p>
      <ul className="data-list">
        <li><strong>Essential Cookies:</strong> Required for login sessions and core platform functionality</li>
        <li><strong>Analytics Cookies:</strong> To understand website traffic and usage patterns</li>
        <li><strong>Preference Cookies:</strong> To remember your language and settings preferences</li>
      </ul>
      <p>Cookies can be disabled through your browser settings, but some features may not work properly.</p>
    </>),
  },
  {
    num: "06", id: "rights", title: "Your Rights",
    content: (<>
      <p>Under the Indian IT Act and PDPB, you have the following rights:</p>
      <ul className="data-list">
        <li>Right to view and download your personal data</li>
        <li>Right to correct inaccurate or incomplete information</li>
        <li>Right to delete your account and associated data</li>
        <li>Right to opt-out of marketing emails at any time</li>
        <li>Data portability – right to export your information</li>
      </ul>
      <p>To exercise these rights, contact us at msmahajan79@gmail.com</p>
    </>),
  },
  {
    num: "07", id: "children", title: "Children's Privacy",
    content: (<>
      <p>Since ITI Expert Guruji is designed for students, children's privacy is our highest priority:</p>
      <ul className="data-list">
        <li>Written parental consent is required for children under 13 years of age</li>
        <li>Student information is never used for advertising purposes</li>
        <li>Students enrolled via schools — their data is accessible to the institution</li>
      </ul>
      <div className="highlight-box">Parents have the right to view and delete their child's account information at any time.</div>
    </>),
  },
  {
    num: "08", id: "changes", title: "Changes to This Policy",
    content: (<>
      <p>ITI Expert Guruji may update this Privacy Policy at any time. When changes occur:</p>
      <ul className="data-list">
        <li>The updated version will be published on the website immediately</li>
        <li>Registered users will receive an email notification</li>
        <li>A banner will be displayed on the platform for significant changes</li>
      </ul>
      <p>Continued use of the platform after any changes implies acceptance of the updated policy.</p>
    </>),
  },
];

export default function PrivacyPolicy() {
  useEffect(() => {
    const el = document.createElement("style");
    el.textContent = styles;
    document.head.appendChild(el);
    return () => document.head.removeChild(el);
  }, []);

  return (
    <div className="policy-page">
      <div className="policy-hero">
        <div className="brand-badge"><div className="brand-dot" /><span className="brand-name">ITI Expert Guruji</span></div>
        <h1 className="policy-title">Privacy Policy</h1>
        <p className="policy-subtitle">Protecting your information is our first and foremost responsibility.</p>
        <div className="policy-meta">
          <span className="meta-chip">📅 Effective: January 1, 2025</span>
          <span className="meta-chip">🔄 Version 2.0</span>
          <span className="meta-chip">📍 Maharashtra, India</span>
        </div>
      </div>
      <div className="policy-body">
        <div className="toc-card">
          <h2 className="toc-title">Table of Contents</h2>
          <ul className="toc-list">
            {sections.map((s, i) => (
              <li key={s.id} className="toc-item">
                <a href={`#${s.id}`}><span className="toc-num">{i + 1}</span>{s.title}</a>
              </li>
            ))}
          </ul>
        </div>
        {sections.map((section) => (
          <div key={section.id} id={section.id} className="policy-section">
            <div className="section-header">
              <div className="section-number">{section.num}</div>
              <h2 className="section-title">{section.title}</h2>
            </div>
            <div className="section-content">{section.content}</div>
          </div>
        ))}
        <div className="contact-card">
          <h3>Have Questions?</h3>
          <p>Contact us for any privacy-related concerns</p>
          <div className="contact-links">
            <a href="mailto:msmahajan79@gmail.com" className="contact-link">✉ msmahajan79@gmail.com</a>
            <a href="tel:+919421989575" className="contact-link">📞 +91  9421989575</a>
          </div>
        </div>
      </div>
    </div>
  );
}
